import qs from 'qs'

const generateFormData = (data, options = {}) => {
  const formData = new FormData()
  const { filenames = {} } = options

  Object.keys(data).forEach(key => {
    if (typeof filenames[key] === 'string') {
      formData.append(key, data[key], filenames[key])
      return
    }

    formData.append(key, data[key])
  })

  return formData
}

export default (data, contentType = 'application/json', options) => {
  switch (contentType) {
    case 'application/x-www-form-urlencoded':
      return qs.stringify(data)
    case 'multipart/form-data':
      return generateFormData(data, options)
    default:
      break
  }
  return data
}
